import { render, staticRenderFns } from "./translate.vue?vue&type=template&id=cd1d3d46&"
import script from "./translate.vue?vue&type=script&lang=js&"
export * from "./translate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports